/**
 * Calculate sales commission flat amount from percentage based on markup
 * @param markupFlat - The equipment markup flat amount
 * @param salesCommissionPercent - The sales commission percentage
 * @returns The calculated sales commission flat amount rounded to 2 decimal places
 */
export function calculateSalesCommissionFlat(markupFlat: number, salesCommissionPercent: number): number {
  return +(markupFlat * (salesCommissionPercent / 100)).toFixed(2);
}

/**
 * Calculate sales commission percentage from flat amount based on markup
 * @param markupFlat - The equipment markup flat amount
 * @param salesCommissionFlat - The sales commission flat amount
 * @returns The calculated sales commission percentage rounded to 2 decimal places
 */
export function calculateSalesCommissionPercent(markupFlat: number, salesCommissionFlat: number): number {
  return +((salesCommissionFlat / markupFlat) * 100).toFixed(2);
}
